import React from 'react';

const Section = React.forwardRef((props, ref) => {
	const { children, ...otherProps } = props;
	return <section ref={ref} {...otherProps}>{children}</section>;
});

export default Section;
